import gql from 'graphql-tag';

export default gql`
    mutation Dnuoperate($input: DnuOperateInput) {
        dnuoperate(input: $input) {
            errors
        }
    }
`;
